const getBinarySensorStateDescription = (sensorType: string, sensorValue: string): string => {
  if (!sensorType || !sensorValue) {
    throw new Error('sensor unsupported')
  }
  return `${sensorType.toLowerCase()} is ${sensorValue}`
}

export default getBinarySensorStateDescription
